import { render, staticRenderFns } from "./successTransaction.vue?vue&type=template&id=0d347c18&scoped=true&"
import script from "./successTransaction.vue?vue&type=script&lang=js&"
export * from "./successTransaction.vue?vue&type=script&lang=js&"
import style0 from "./successTransaction.vue?vue&type=style&index=0&id=0d347c18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d347c18",
  null
  
)

export default component.exports